var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#F8FAFC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M17 2h-3a5 5 0 0 0-5 5v3H6v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3V2Z"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
